import React, {useContext, useEffect, useState} from "react";
import {Menu, type MenuProps, theme} from "antd";
import Sider from "antd/es/layout/Sider";
import {RiBardLine, RiFileSearchLine, RiSearchEyeLine} from "react-icons/ri";
import {TiDocumentText} from "react-icons/ti";
import {BsSearchHeart} from "react-icons/bs";
import {AuthContext} from "../../../../config/AuthContext";
import {MdOutlineRateReview} from "react-icons/md";

interface Props {
    setPantalla: (value: number) => void;
}

const AppSiderActivitatsId = (props: Props) => {
    const [pantalla, setPantalla] = useState(0);
    const {isLoggedIn, userId, user, setBreadCrumb} = useContext(AuthContext);

    useEffect(() => {
        document.title = 'Web Dubtes';
    }, []);

    const titles: string[] = ['Exercicis'];

    const items: MenuProps['items'] = [MdOutlineRateReview].map(
        (icon, index) => {
            const key = String(index + 1);

            return {
                key: key,
                icon: React.createElement(icon),
                label: titles[index],
                onClick: () => (setPantalla(index), props.setPantalla(index))
            };
        },
    );
    const {
        token: {colorBgContainer, borderRadiusLG},
    } = theme.useToken();

    return (
        <Sider style={{background: colorBgContainer}} width={200}>
            <Menu
                mode="inline"
                defaultSelectedKeys={[(pantalla + 1) + ""]}
                defaultOpenKeys={['sub1']}
                style={{height: '100%'}}
                items={user.tipus === "0" || user.tipus === "1" ? items : []}
            />
        </Sider>
    );
}

export default AppSiderActivitatsId;